'use strict';

var React = require('react');

var SvgImageWithTextMajor = function SvgImageWithTextMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5h-6zm16.5 4h-6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zm-6 4h6a1 1 0 1 0 0-2h-6a1 1 0 1 0 0 2zm6 4h-17a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2zm-3.293 3.707a1 1 0 0 1-.707.293h-13a1 1 0 0 1 0-2h13a1 1 0 0 1 .707 1.707z"
  }));
};

exports.SvgImageWithTextMajor = SvgImageWithTextMajor;
